// @todo: Migrate to 'Dialog.Drawer' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import Drawer from '@material-ui/core/Drawer';
// @todo: Migrate to @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components/Button';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import React, {useState} from 'react';

import {ResizableDrawer} from './ResizableDrawer';
// eslint-disable-next-line import/no-cycle -- please fix if you can
import {GenericWebhook} from './WebhooksTable';

type ViewWebhookDrawerProps = {
  open: boolean;
  closeDrawer: () => void;

  genericWebhook?: GenericWebhook;
  entityName: string;
  isPersonalEntity?: boolean;
};

export const ViewWebhookDrawer = ({
  open,
  closeDrawer,
  genericWebhook,
  entityName,
  isPersonalEntity,
}: ViewWebhookDrawerProps) => {
  const [width, setWidth] = useState(600); // Remember last size
  const onSetWidth = (newWidth: number) => {
    setWidth(newWidth);
  };
  if (genericWebhook == null) {
    return (
      <Drawer anchor="right" open={open} onClose={closeDrawer}>
        <ResizableDrawer
          startWidth={width}
          minWidth={600}
          onSetWidth={onSetWidth}
        />
      </Drawer>
    );
  }
  const date = new Date(genericWebhook.createdAt);
  const createdDate = date.toDateString();
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={closeDrawer}
      style={{position: 'absolute', zIndex: '2000'}}>
      {/*Setting the z-index above to 2000 since we want to render over the SearchNavBar. See frontends/app/src/css/SearchNav.less*/}
      <ResizableDrawer
        startWidth={width}
        minWidth={600}
        onSetWidth={onSetWidth}>
        <Tailwind style={{width: '100%', height: '100%'}}>
          <div className="h-full w-full px-24 py-20">
            <div className="flex h-full w-full flex-col">
              <div className="mb-20 flex items-center">
                <div className="text-xl font-semibold leading-8">
                  {genericWebhook.name}
                </div>
                <div className="flex-1 text-right">
                  <Button
                    onClick={closeDrawer}
                    icon="close"
                    size="large"
                    variant="ghost"
                  />
                </div>
              </div>
              <div className="-mx-20 h-1 bg-moon-250"></div>
              <div className="w-full flex-1 overflow-auto p-4">
                <div className="mb-4 mt-16 flex w-full justify-between">
                  <div className="w-1/3 text-left text-base leading-6 text-moon-550">
                    Name
                  </div>
                  <div className="text-gray-800 w-2/3 whitespace-normal break-all text-left text-base leading-6">
                    {genericWebhook.name}
                  </div>
                </div>
                <div className="mb-4 mt-16 flex w-full justify-between">
                  <div className="w-1/3 text-left text-base leading-6 text-moon-550">
                    URL
                  </div>
                  <div className="text-gray-800 w-2/3 whitespace-normal break-all text-left text-base leading-6">
                    {genericWebhook.urlEndpoint}
                  </div>
                </div>
                <div className="mb-4 mt-16 flex w-full justify-between">
                  <div className="w-1/3 text-left text-base leading-6 text-moon-550">
                    Access token used
                  </div>
                  <div className="text-gray-800 w-2/3 whitespace-normal break-all text-left text-base leading-6">
                    {genericWebhook.accessTokenRef ?? 'None'}
                  </div>
                </div>
                <div className="mb-4 mt-16 flex w-full justify-between">
                  <div className="w-1/3 text-left text-base leading-6 text-moon-550">
                    Secret used
                  </div>
                  <div className="text-gray-800 w-2/3 whitespace-normal break-all text-left text-base leading-6">
                    {genericWebhook.secretRef ?? 'None'}
                  </div>
                </div>
                <div className="mb-4 mt-16 flex w-full justify-between">
                  <div className="w-1/3 text-left text-base leading-6 text-moon-550">
                    {!isPersonalEntity ? 'Team' : 'User profile'}
                  </div>
                  <div className="text-gray-800 w-2/3 whitespace-normal break-all text-left text-base leading-6">
                    {entityName}
                  </div>
                </div>
                <div className="mb-4 mt-16 flex w-full justify-between">
                  <div className="w-1/3 text-left text-base leading-6 text-moon-550">
                    Date created
                  </div>
                  <div className="text-gray-800 w-2/3 whitespace-normal break-all text-left text-base leading-6">
                    {createdDate}
                  </div>
                </div>
              </div>
              <div className="-mx-20 h-1 bg-moon-250"></div>
              <div className="flex items-center pt-20">
                <Button
                  variant="primary"
                  size="large"
                  className="w-full"
                  onClick={closeDrawer}>
                  Done
                </Button>
              </div>
            </div>
          </div>
        </Tailwind>
      </ResizableDrawer>
    </Drawer>
  );
};
